import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    paddingBottom: 10
  },
  filtersContainer: {
    paddingTop: 30,
    display: 'grid',
    gridTemplateColumns: '4fr 1fr',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    paddingBottom: 10,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  actionAndKeywordsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  actionAutocompleteContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 64,
    padding: '0px 24px'
  },
  keywordsFieldContainer: {
    marginLeft: 40,
    marginRight: 117,
    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px 12px 0px'
    }
  },
  datePickerContainer: {
    marginTop: 21,
    marginRight: 57,
    width: 282,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  buttonOfDate: {
    width: 282,
    height: 50,
    textAlign: 'left',
    '& span': {
      margin: '12px 0px',
      fontSize: 14
    }
  },
  dateRangePicker: {
    position: 'absolute',
    right: -2,
    top: -8,
    zIndex: 1
  },
  textShowOnButtonParrent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textShowOnButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginLeft: -48
  },
  textShowOnButtonAfterClickOnTimePeriodButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginBottom: -16,
    marginLeft: -48,
    '& p:last-child': {
      marginLeft: 12
    }
  },
  textShowOnButtonAfterSelectDateForArrivalDateAndDeparture: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: -8,
    '& p': {
      color: `${theme.palette.grey[100]} !important`
    },
    '& p:last-child': {
      marginLeft: 20
    }
  },
  typographyOfButton: {
    color: `${theme.palette.grey[200]} !important`
  },
  typographyOfButtonAfterSelectDate: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 12,
    fontWeight: 500
  },
  typographyOfButtonAfterSelectDateForArrivalDateAndDeparture: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 13,
    fontWeight: 700
  },
  arrowIcon: {
    marginBottom: '0px !important',
    marginLeft: '20px !important'
  },
  buttonsContainer: {
    marginRight: 55,
    marginTop: 50,
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end',
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[200]}`
    },
    [theme.breakpoints.down('sm')]: {
      margin: '50px 0px 0px 0px'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
